import { View } from 'foundations-components/transitional/components/View';
import { useTheme } from 'foundations-theming/utils';
import { SkeletonBlock, SkeletonWrapper } from '../../Skeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SkeletonFeaturedSoftwareCoursesHeader = () => {
  const theme = useTheme();
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(View, {
      marginBlock: "100",
      children: /*#__PURE__*/_jsx(SkeletonWrapper, {
        height: "14px",
        shimmerColor: theme.color['fill-surface-default'],
        width: "220px",
        children: /*#__PURE__*/_jsx(SkeletonBlock, {
          color: "fill-surface-recessed",
          height: "100%",
          width: "100%"
        })
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlock: "100",
      children: /*#__PURE__*/_jsx(SkeletonWrapper, {
        height: "14px",
        shimmerColor: theme.color['fill-surface-default'],
        width: "180px",
        children: /*#__PURE__*/_jsx(SkeletonBlock, {
          color: "fill-surface-recessed",
          height: "100%",
          width: "100%"
        })
      })
    })]
  });
};
export default SkeletonFeaturedSoftwareCoursesHeader;